export default __webpack_public_path__ + "static/media/Standard46.6a6d1496.png";